// used by mailchimp
"use client"
import { useState, useEffect } from 'react';

const TagPill_2 = ({ caption, groupId, defaultChecked  }) => {

     const [checked, setChecked] = useState(false)

     const handleCheck = (checkedId) => {
          if (checked === checkedId){
               setChecked(!checked)
          }
          else { 
               setChecked(checkedId)
          }
     }

     useEffect(() => {
       defaultChecked && setChecked(groupId)
     }, [defaultChecked])
     
     return (
          // <label class="tagbox-mailchimp" for="group_1">
          // <input type="checkbox" id="group_1" name="group[22182][1]" value="1" class="av-checkbox" onClick={()=>tagCheck(1)}/>
          // C#
          // </label>
          <label 
          className={`cursor-pointer ${checked === groupId ? 'bg-indigo-700 dark:bg-indigo-700 text-white dark:text-white' : 'bg-gray-100'} bg-gray-200 dark:text-gray-400 dark:bg-slate-800 inline-flex items-center rounded m-1 px-3 text-xs py-1 duration-300 hover:bg-indigo-700 hover:text-white font-inter`} 
          htmlFor={`group_${groupId}`}
          >
          <input 
               type="checkbox" 
               id={`group_${groupId}`} 
               name={`group[22182][${groupId}]`} 
               value={groupId} 
               className="av-checkbox" 
               onClick={()=>handleCheck(groupId)}
               style={{ opacity: 0, width: 0, height: 0}}
          />
          {caption}
          </label>

     // <input type="checkbox" 
     //      className={`cursor-pointer ${checked === groupId ? 'checked' : 'unchecked'} bg-gray-200 inline-flex items-center rounded border px-3 py-0 m-1`} 
     //      id={`group_${groupId}`} 
     //      name={`group[22182][${groupId}]`} 
     //      value={groupId} onClick={()=>handleCheck(groupId)}
     //      style={{fontSize:'12px'}}
     // >
     //      {caption}
     // </input>
)};

export default TagPill_2




